import { TempActions } from '@mode/charts/domain';
import { AppState, ExplorerState } from '@mode/legacy/types-app-state';
import { ReducerTree } from '@mode/legacy/util-domain';
import { SharedChartCommandActionType } from '../../actions/chart-commands/shared.actions';
import { ExplorerActionType } from '../../actions/chart-designer/explorer.actions';
import { Actions } from '../../actions/index';
import { RouterActionType } from '../../actions/router-actions';
import { isExplorerRoute } from '../../lib/router-helpers';

export const initialTransientExplorerState: ExplorerState = {
  chartToken: null,
  isOpen: false,
  isFocused: false,
};

export function chartTokenReducer(
  state = initialTransientExplorerState.chartToken,
  action: Actions
): ExplorerState['chartToken'] {
  switch (action.type) {
    case ExplorerActionType.ExploreChart:
    case TempActions.Type.ExploreChartMark:
    case ExplorerActionType.ExploreChartOnLoad:
    case TempActions.Type.ExploreChartWithData:
      return action.chartToken;
    default:
      return state;
  }
}

export function isOpenReducer(state = initialTransientExplorerState.isOpen, action: Actions): ExplorerState['isOpen'] {
  switch (action.type) {
    case RouterActionType.UpdateRoute:
      return isExplorerRoute(action.payload.name);
    case ExplorerActionType.ExploreChart:
    case TempActions.Type.ExploreChartMark:
    case ExplorerActionType.ExploreChartOnLoad:
    case TempActions.Type.ExploreChartWithData:
    case ExplorerActionType.ViewChartData:
      return true;
    case ExplorerActionType.CloseExploration:
    case SharedChartCommandActionType.CloseAllModals:
      return false;
  }

  return state;
}

export function isFocusedReducer(
  state = initialTransientExplorerState.isFocused,
  action: Actions
): ExplorerState['isFocused'] {
  switch (action.type) {
    case ExplorerActionType.ExploreChart:
    case TempActions.Type.ExploreChartMark:
    case ExplorerActionType.ExploreChartOnLoad:
      return true;
    case TempActions.Type.ExploreChartWithData:
    case ExplorerActionType.ViewChartData:
    case SharedChartCommandActionType.CloseAllModals:
      return false;
  }

  return state;
}

export const TransientExplorerReducer: ReducerTree<AppState, ExplorerState, Actions> = {
  chartToken: chartTokenReducer,
  isOpen: isOpenReducer,
  isFocused: isFocusedReducer,
};
